/**
 * swak-campus.js
 * Phase 0c — Campus cookie set/read + mega menu toggle + home link wiring
 * Phase 0d — Landing page hero, announcement bar, and subtitle swaps
 * Establishes and persists campus context via swak_campus cookie.
 *
 * Cookie: swak_campus={slug}  e.g. swak_campus=nau
 * Expiry: 30 days
 * Path:   /
 *
 * Usage (from other scripts):
 *   const slug = window.SWAK.getCampusSlug();
 */

(function () {
  'use strict';

  // ── Cookie helpers ────────────────────────────────────────────────

  function setCampusCookie(slug) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    document.cookie = [
      'swak_campus=' + encodeURIComponent(slug),
      'expires=' + expires.toUTCString(),
      'path=/',
      'SameSite=Lax'
    ].join('; ');
  }

  function getCampusCookie() {
    const match = document.cookie.match(/(?:^|;\s*)swak_campus=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // ── Slug detection ────────────────────────────────────────────────

  function getSlugFromUrl() {
    const match = window.location.pathname.match(/^\/pages\/([^\/]+)$/);
    return match ? match[1] : null;
  }

  function getCampusSlug() {
    // SWAK 2026-06-29 — Cookie takes priority; URL slug only used on campus landing pages
    const cookie = getCampusCookie();
    const urlSlug = getSlugFromUrl();
    // Only use URL slug if it's a valid campus in the data
    if (urlSlug && window.SWAK_CAMPUS_DATA && window.SWAK_CAMPUS_DATA[urlSlug]) return urlSlug;
    return cookie || null;
    // SWAK 2026-06-29 END
  }

  // ── Mega menu helpers ─────────────────────────────────────────────

 // ===== SWAK CHANGE START — 2026-07-22 — use startsWith instead of exact match to handle anchors with subtitle text appended =====
      function findNavAnchorByText(text) {
    const anchors = document.querySelectorAll('nav a, .mega-menu a, header a');
    for (const a of anchors) {
      if (a.closest('.menu-drawer')) continue;
      var span = a.querySelector('.wrap-text');
      var label = span ? span.textContent.trim().toLowerCase() : a.textContent.trim().toLowerCase();
      if (label === text.toLowerCase()) {
        return a;
      }
    }
    return null;
  }

// ===== SWAK CHANGE END — 2026-07-22 =====

  function toggleMegaLink(linkText, show) {
    const a = findNavAnchorByText(linkText);
    if (!a) return;
    const li = a.closest('li');
    if (!li) return;
    if (show) {
      li.classList.remove('swak-hidden');
    } else {
      li.classList.add('swak-hidden');
    }
  }
 
// ===== SWAK CHANGE START — 2026-07-10 — use mega-menu__column as container to find all child links; excludes mobile drawer =====
function toggleChildLink(parentText, childText, show) {
  const parentA = findNavAnchorByText(parentText);
  if (!parentA) return;
  const container = parentA.closest('li.mega-menu__column');
  if (!container) return;
  const childAnchors = container.querySelectorAll('a');
  for (const a of childAnchors) {
    if (a.textContent.trim().toLowerCase().startsWith(childText.toLowerCase())) {
      const childLi = a.closest('li');
      if (childLi) {
        if (show) {
          childLi.classList.remove('swak-hidden');
        } else {
          childLi.classList.add('swak-hidden');
        }
      }
    }
  }
}
// ===== SWAK CHANGE END — 2026-07-10 =====
// ===== SWAK CHANGE START — 2026-07-11 — drawer-specific toggles using summary IDs, no textContent =====
function applyDrawerToggles() {
  const slug = getCampusSlug();
  if (!slug || !window.SWAK_CAMPUS_DATA) return;
  const d = window.SWAK_CAMPUS_DATA[slug];
  if (!d) return;

  console.debug('[SWAK] Applying drawer toggles for:', slug);

  function drawerToggle(id, show) {
    const el = document.getElementById(id);
    if (!el) return;
    const li = el.closest('li');
    if (!li) return;
    li.style.display = show ? '' : 'none';
  }

  // Top-level Care Packages and Room Essentials
  drawerToggle('HeaderDrawer-care-packages',   d.care_on || d.care_off);
  drawerToggle('HeaderDrawer-room-essentials', d.room_on || d.room_off);

  // Room Essentials children
  drawerToggle('HeaderDrawer-room-essentials-on-campus-room-essentials',  d.room_on);
  drawerToggle('HeaderDrawer-room-essentials-off-campus-room-essentials', d.room_off);

  // On-campus Care Package events
  drawerToggle('HeaderDrawer-care-packages-on-campus-care-packages-welcome',         d.care_on_welcome);
  drawerToggle('HeaderDrawer-care-packages-on-campus-care-packages-halloween',       d.care_on_halloween);
  drawerToggle('HeaderDrawer-care-packages-on-campus-care-packages-fall-finals',     d.care_on_fallfinals);
  drawerToggle('HeaderDrawer-care-packages-on-campus-care-packages-valentines',      d.care_on_valentines);
  drawerToggle('HeaderDrawer-care-packages-on-campus-care-packages-spring-surprise', d.care_on_springsurprise);
  drawerToggle('HeaderDrawer-care-packages-on-campus-care-packages-spring-finals',   d.care_on_springfinals);

  // Off-campus Care Package events
  drawerToggle('HeaderDrawer-care-packages-off-campus-care-packages-welcome',         d.care_off_welcome);
  drawerToggle('HeaderDrawer-care-packages-off-campus-care-packages-halloween',       d.care_off_halloween);
  drawerToggle('HeaderDrawer-care-packages-off-campus-care-packages-fall-finals',     d.care_off_fallfinals);
  drawerToggle('HeaderDrawer-care-packages-off-campus-care-packages-valentines',      d.care_off_valentines);
  drawerToggle('HeaderDrawer-care-packages-off-campus-care-packages-spring-surprise', d.care_off_springsurprise);
  drawerToggle('HeaderDrawer-care-packages-off-campus-care-packages-spring-finals',   d.care_off_springfinals);
}
// ===== SWAK CHANGE END — 2026-07-11 =====

  // ── Apply mega menu toggles from SWAK_CAMPUS_DATA ────────────────

  // ===== SWAK CHANGE START — 2026-07-09 — removed pre-hide reveal from applyMegaMenuToggles; reveal managed by faqObserver =====
  function applyMegaMenuToggles() {
    const slug = getCampusSlug();
    if (!slug || !window.SWAK_CAMPUS_DATA) {
      return;
    }

    const d = window.SWAK_CAMPUS_DATA[slug];
    if (!d) {
      console.debug('[SWAK] No campus data found for slug:', slug);
      return;
    }

    console.debug('[SWAK] Applying mega menu toggles for:', slug);

    // SWAK 2026-07-01 — Hide top-level Care/Room if both on and off campus are disabled
    toggleMegaLink('care packages', d.care_on || d.care_off);
    toggleMegaLink('room essentials', d.room_on || d.room_off);
    // SWAK 2026-07-01 END

    toggleMegaLink('on-campus room essentials', d.room_on);
    toggleMegaLink('off-campus room essentials', d.room_off);

    toggleChildLink('on-campus care packages', 'welcome',         d.care_on_welcome);
    toggleChildLink('on-campus care packages', 'halloween',       d.care_on_halloween);
    toggleChildLink('on-campus care packages', 'fall finals',     d.care_on_fallfinals);
    toggleChildLink('on-campus care packages', 'valentines',      d.care_on_valentines);
    toggleChildLink('on-campus care packages', 'spring surprise', d.care_on_springsurprise);
    toggleChildLink('on-campus care packages', 'spring finals',   d.care_on_springfinals);

    toggleChildLink('off-campus care packages', 'welcome',         d.care_off_welcome);
    toggleChildLink('off-campus care packages', 'halloween',       d.care_off_halloween);
    toggleChildLink('off-campus care packages', 'fall finals',     d.care_off_fallfinals);
    toggleChildLink('off-campus care packages', 'valentines',      d.care_off_valentines);
    toggleChildLink('off-campus care packages', 'spring surprise', d.care_off_springsurprise);
    toggleChildLink('off-campus care packages', 'spring finals',   d.care_off_springfinals);
  }
  // ===== SWAK CHANGE END — 2026-07-09 =====

  // ── Wire Home link to campus page ────────────────────────────────
  // SWAK 2026-06-25 — Wire Home link to campus page.
  // If already on the campus page, suppress navigation and scroll to top.
  // Prevents full page reload flash when clicking Home on a campus landing page.
  function wireHomeLink() {
    const slug = getCampusSlug();
    if (!slug) return;

    document.querySelectorAll('nav a, header a').forEach(function (a) {
      if (a.textContent.trim().toLowerCase() === 'home') {
        a.href = '/pages/' + slug;
        console.debug('[SWAK] Home link wired to:', a.href);

        a.addEventListener('click', function (e) {
          if (window.location.pathname === '/pages/' + slug) {
            e.preventDefault();
            // SWAK 2026-06-25 — Close hamburger menu before scrolling to top
            const drawerClose = document.querySelector('button.menu-drawer__close-button');
            if (drawerClose) drawerClose.click();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            console.debug('[SWAK] Already on campus page — navigation suppressed, scrolled to top.');
          }
        });
      }
    });
  }

  // ── Landing page swaps (Phase 0d) ────────────────────────────────
  // Only runs on campus pages (/pages/{slug}).
  // Swaps announcement bar, hero image, and hero subtitle.

  function applyLandingPageSwaps() {
    // SWAK 2026-07-01 — Exclude root homepage from campus branding
    if (window.location.pathname === '/') return;
    // SWAK 2026-06-29 — Allow shared pages to receive campus branding via cookie
    var SHARED_CAMPUS_PAGES = ['/pages/key-dates','/pages/care-package-faq','/pages/room-essentials-faq','/pages/contact'];
    var isSharedPage = SHARED_CAMPUS_PAGES.indexOf(window.location.pathname) !== -1;
    // SWAK 2026-07-01 — Allow all pages to receive campus branding if cookie is set
    if (!getSlugFromUrl() && !isSharedPage && !getCampusCookie()) return;
    // SWAK 2026-07-01 END

    const slug = getCampusSlug();
    if (!slug || !window.SWAK_CAMPUS_DATA) {
      document.documentElement.style.opacity = '1';
      document.body.style.opacity = '1';
      return;
    }

    const d = window.SWAK_CAMPUS_DATA[slug];
    if (!d) {
      document.documentElement.style.opacity = '1';
      document.body.style.opacity = '1';
      return;
    }

    // Hide hero content immediately to prevent default flash
    const heroTitle = document.querySelector('.swak-hero-title');
    const heroMedia = document.querySelector('[data-testid="hero-media-wrapper"]');
    if (heroTitle) heroTitle.style.visibility = 'hidden';
    if (heroMedia) heroMedia.style.visibility = 'hidden';

    // 1. Announcement bar text → campus name
    if (d.name) {
      const barText = document.querySelector('p.announcement-bar__text');
      if (barText) {
        barText.textContent = d.name;
        console.debug('[SWAK] Announcement bar text set to:', d.name);
      }
    }

// 2. Announcement bar background → color_bar_bg (bg/border keys) or primary_color fallback
// 2026-08-20 — color_bar_bg: parse bg and border keys — START
// 2026-08-20 — border fix: apply border to full-width aside element — UPDATE
var barBgRaw = d.color_bar_bg || '';
var barParts = {};
barBgRaw.split(';').forEach(function(p) {
  var kv = p.split('='); if (kv.length === 2) barParts[kv[0].trim()] = kv[1].trim();
});
// 2026-08-20 — plain hex fallback: if no bg= key, treat raw value as bg color — START
if (!barParts.bg && barBgRaw.startsWith('#')) {
  barParts.bg = barBgRaw.trim();
}
// 2026-08-20 — plain hex fallback: if no bg= key, treat raw value as bg color — END
var barBgColor = barParts.bg || d.primary_color || null;
var barBorderColor = barParts.border || null;

const barWrap = document.querySelector('announcement-bar-component');
const barSection = document.querySelector('.section-background.color-scheme-announcement');
const barAside = document.querySelector('aside.announcement-bar.section--page-width');

if (barBgColor) {
  if (barAside) barAside.style.backgroundColor = barBgColor;
  if (barWrap) barWrap.style.backgroundColor = barBgColor;
  if (barSection) barSection.style.backgroundColor = barBgColor;
  console.debug('[SWAK] Announcement bar background set to:', barBgColor);
}
if (barBorderColor) {
  if (barAside) {
    barAside.style.borderBottomWidth = '3px';
    barAside.style.borderBottomStyle = 'solid';
    barAside.style.borderBottomColor = barBorderColor;
  }
  if (barWrap) barWrap.style.borderBottom = 'none';
  if (barSection) barSection.style.borderBottom = 'none';
  console.debug('[SWAK] Announcement bar border set to:', barBorderColor);
} else {
  if (barAside) barAside.style.borderBottom = 'none';
  if (barWrap) barWrap.style.borderBottom = 'none';
  if (barSection) barSection.style.borderBottom = 'none';
}
// 2026-08-20 — color_bar_bg: parse bg and border keys — END

// 2b. Announcement bar text color → color_bar_text override or #ffffff fallback
const barTextColor = d.color_bar_text || '#ffffff';
const barTextEl = document.querySelector('p.announcement-bar__text');
if (barTextEl) {
  barTextEl.style.color = barTextColor;
  console.debug('[SWAK] Announcement bar text color set to:', barTextColor);
}

    // ── SWAK 2026-06-26 Phase 0d: Button color ───────────────────────
    if (d.primary_color) {
      const styleId = 'swak-campus-colors';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;

        // ===== SWAK CHANGE START — 2026-07-03 20:30 CDT — parse color_buttons and color_fulfillment =====
        const btnParts = {};
        if (d.color_buttons) {
          d.color_buttons.split(';').forEach(function(pair) {
            const kv = pair.split('=');
            if (kv.length === 2 && kv[1].trim()) btnParts[kv[0].trim()] = kv[1].trim();
          });
        }
        const fulParts = {};
        if (d.color_fulfillment) {
          d.color_fulfillment.split(';').forEach(function(pair) {
            const kv = pair.split('=');
            if (kv.length === 2 && kv[1].trim()) fulParts[kv[0].trim()] = kv[1].trim();
          });
        }
        // ===== SWAK CHANGE END — 2026-07-03 20:30 CDT =====

        const cssLines = [
          ':root { --school-primary: ' + d.primary_color + '; }',
          '#swak-room-essentials h2 { color: ' + (d.color_heading_room || '#ffffff') + ' !important; }',
          '#swak-room-essentials .swak-bundles-text h3, #swak-room-essentials .swak-bundles-wrapper h3 { color: ' + (d.color_heading_bundles || d.primary_color) + ' !important; }',
          '.swak-care-top h2 { color: ' + (d.color_heading_care_top || '#ffffff') + ' !important; }',
          '.swak-care-bottom h3 { color: ' + (d.color_heading_care_bottom || d.primary_color) + ' !important; }',
          '.swak-care-discount-list li::before { color: ' + (d.color_heading_care_top || '#ffffff') + ' !important; }',
          '.swak-hero-title { --color-foreground-heading: ' + (d.color_hero_text || '#ffffff') + '; }',
          '.swak-hero-title__subheadline, .swak-hero-title__subheadline strong { color: ' + (d.color_hero_text || '#ffffff') + ' !important; }',
          // 2026-07-21 — apply color_hero_text to non-landing page hero h1 and p — START
          '.hero h1 { color: ' + (d.color_hero_text || '#ffffff') + ' !important; }',
          '.hero p, .hero p strong { color: ' + (d.color_hero_text || '#ffffff') + ' !important; }',
          // 2026-07-21 — apply color_hero_text to non-landing page hero h1 and p — END
          // 2026-07-21 — apply color_hero_text to collection page hero h1 and p — START
          '.section-content-wrapper h1 { color: ' + (d.color_hero_text || '#ffffff') + ' !important; }',
          '.section-content-wrapper p, .section-content-wrapper p strong { color: ' + (d.color_hero_text || '#ffffff') + ' !important; }',
          // 2026-07-21 — apply color_hero_text to collection page hero h1 and p — END
        ];

        // ===== SWAK CHANGE START — 2026-07-03 21:57 CDT — corrected button selectors =====
        if (btnParts.btn1_bg)   cssLines.push('#swak-room-essentials a.swak-cta:not(.swak-cta--light), button.swak-footer__signup-btn { background-color: ' + btnParts.btn1_bg + ' !important; }');
        if (btnParts.btn1_text) cssLines.push('#swak-room-essentials a.swak-cta:not(.swak-cta--light), button.swak-footer__signup-btn { color: ' + btnParts.btn1_text + ' !important; }');
        if (btnParts.btn2_bg)   cssLines.push('a.swak-cta.swak-cta--light, a.swak-care-cta { background-color: ' + btnParts.btn2_bg + ' !important; }');
        if (btnParts.btn2_text) cssLines.push('a.swak-cta.swak-cta--light, a.swak-care-cta { color: ' + btnParts.btn2_text + ' !important; }');
        // ===== SWAK CHANGE END — 2026-07-03 21:57 CDT =====
        // ===== SWAK CHANGE START — 2026-07-03 22:11 CDT — corrected fulfillment selectors =====
        if (fulParts.bg)   cssLines.push('.swak-fulfillment__bottom { background-color: ' + fulParts.bg + ' !important; }');
        if (fulParts.text) cssLines.push('.swak-fulfillment__bbb, .swak-fulfillment__bottom * { color: ' + fulParts.text + ' !important; }');
        // ===== SWAK CHANGE END — 2026-07-03 22:11 CDT =====

        style.textContent = cssLines.join('\n');
        document.head.appendChild(style);
        console.debug('[SWAK] --school-primary set to:', d.primary_color);
      }
    }
    // ── END SWAK 2026-06-26 Phase 0d: Button color ───────────────────

    // 3. Hero image → campus hero_image CDN URL
    if (d.hero_image) {
      const heroImg = document.querySelector('[data-testid="hero-desktop-image-1"]');
      if (heroImg) {
        heroImg.src = d.hero_image;
        heroImg.srcset = d.hero_image;
        console.debug('[SWAK] Hero image set to:', d.hero_image);
      }
    }

    // SWAK 2026-07-01 — Swap background-image-container img on collection/product/shared pages
    if (d.hero_image) {
      const bgImg = document.querySelector('div.background-image-container img');
      if (bgImg) {
        bgImg.src = d.hero_image;
        bgImg.srcset = d.hero_image;
        console.debug('[SWAK] Background image container swapped to:', d.hero_image);
      }
    }
    // SWAK 2026-07-01 END

    // 4. Hero subtitle → partnership sentence
    if (d.sponsor_org && d.sponsor_school) {
      const subtitle = document.querySelector('.swak-hero-title__subheadline strong');
      if (subtitle) {
        subtitle.textContent = 'Proudly partnering with ' + d.sponsor_org +
          ' at ' + d.sponsor_school +
          ' to make college life easier \u2014 from move-in day to graduation.';
        console.debug('[SWAK] Hero subtitle set for:', slug);
      }
    }

    //  5. FAQ toggles — footer, mega menu, mobile drawer
    function applyFaqToggles() {
      console.debug('[SWAK] FAQ toggle — care:', d.care_on, d.care_off, 'room:', d.room_on, d.room_off);
      var footer = document.querySelector('.swak-footer');
      if (footer) {
        var careFooter = footer.querySelector('a[href="/pages/care-package-faq"]');
        var roomFooter = footer.querySelector('a[href="/pages/room-essentials-faq"]');
        if (careFooter) careFooter.closest('li').style.display = (d.care_on || d.care_off) ? '' : 'none';
        if (roomFooter) roomFooter.closest('li').style.display = (d.room_on || d.room_off) ? '' : 'none';
      }
            var css = '';
      if (!(d.care_on || d.care_off)) css += 'a.mega-menu__link[href="/pages/care-package-faq"] { display: none !important; }\n';
      if (!(d.room_on || d.room_off)) css += 'a.mega-menu__link[href="/pages/room-essentials-faq"] { display: none !important; }\n';
      var existingStyle = document.getElementById('swak-faq-toggle-style');
      if (existingStyle) {
        if (existingStyle.textContent !== css) existingStyle.textContent = css;
      } else {
        var faqStyle = document.createElement('style');
        faqStyle.id = 'swak-faq-toggle-style';
        faqStyle.textContent = css;
        document.head.appendChild(faqStyle);
      }
      var drawerCare = document.querySelector('#HeaderDrawer-faq-care-package-faq');
      var drawerRoom = document.querySelector('#HeaderDrawer-faq-room-essentials-faq');
      if (drawerCare) drawerCare.closest('li').style.display = (d.care_on || d.care_off) ? '' : 'none';
      if (drawerRoom) drawerRoom.closest('li').style.display = (d.room_on || d.room_off) ? '' : 'none';
      console.debug('[SWAK] FAQ links toggled for:', slug);
    }
 applyFaqToggles();
    // ===== SWAK CHANGE START — 2026-08-10v4 — throttled observer stays alive for full timeout =====
    var faqObserverThrottle = null;
    var faqObserver = new MutationObserver(function() {
      if (faqObserverThrottle) return;
      faqObserverThrottle = setTimeout(function() {
        faqObserverThrottle = null;
        applyFaqToggles();
        applyMegaMenuToggles();
        applyDrawerToggles();
      }, 10);
    });
    faqObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { faqObserver.disconnect(); }, 8000);
    // ===== SWAK CHANGE END — 2026-08-10v4 =====

    const barReveal = document.querySelector('.section-background.color-scheme-announcement');
    if (barReveal) barReveal.style.visibility = 'visible';

    // SWAK 2026-07-01 — Reveal page after all swaps complete (covers both html and body)
    document.documentElement.style.opacity = '1';
    document.body.style.opacity = '1';

    if (heroTitle) heroTitle.style.visibility = 'visible';
    if (heroMedia) heroMedia.style.visibility = 'visible';

    // ===== SWAK CHANGE START — 2026-08-16 — Care Package Badge Gate call =====
    applyCarePackageBadgeGate(d);
    // ===== SWAK CHANGE END — 2026-08-16 — Care Package Badge Gate call =====

  }  // ← closing brace of applyLandingPageSwaps()

   // ── Auto-set cookie on campus pages ──────────────────────────────

  function init() {
    const urlSlug = getSlugFromUrl();
    // SWAK 2026-06-29 — Guard: only set cookie if slug exists in campus data
    if (urlSlug && window.SWAK_CAMPUS_DATA && window.SWAK_CAMPUS_DATA[urlSlug]) {
      setCampusCookie(urlSlug);
      console.debug('[SWAK] Campus cookie set:', urlSlug);
    } else if (urlSlug) {
      console.debug('[SWAK] setCampusCookie blocked — slug not in campus data:', urlSlug);
    // SWAK 2026-06-29 END
    } else {
      const cookieSlug = getCampusCookie();
      if (cookieSlug) {
        console.debug('[SWAK] Campus cookie read:', cookieSlug);
      } else {
        console.debug('[SWAK] No campus context.');
      }
    }

    // ===== SWAK CHANGE START — 2026-07-11 — run drawer toggles on hamburger open, not page load =====
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', function() {
        if (drawerDetails.open) {
          applyDrawerToggles();
        }
      });
    }
    // ===== SWAK CHANGE END — 2026-07-11 =====
    wireHomeLink();
    applyLandingPageSwaps();

    // Safety reveal — non-campus pages or early-exit cases where swak-mega-pre-hide survives
    setTimeout(function() {
      var hideStyle = document.getElementById('swak-mega-pre-hide');
      if (hideStyle) hideStyle.remove();
    }, 1000);
    // ===== SWAK CHANGE END — 2026-07-09 =====

    // ===== SWAK CHANGE START — 2026-07-05 — re-stamp swak_campus and _internal_order_code on campus page arrival =====
    if (urlSlug && window.SWAK_CAMPUS_DATA && window.SWAK_CAMPUS_DATA[urlSlug]) {
      const _campusData = window.SWAK_CAMPUS_DATA[urlSlug];
      const _internalCode = _campusData.internal_order_code || '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            swak_campus: urlSlug,
            _internal_order_code: _internalCode
          }
        })
      }).then(function() {
        console.debug('[SWAK] Cart campus stamped:', urlSlug, _internalCode);
      });
    }
    // ===== SWAK CHANGE END — 2026-07-05 =====

    // SWAK 2026-06-25 — Safety timeout: reveal page if JS swaps fail for any reason.
    if (getSlugFromUrl() || getCampusCookie()) {
      setTimeout(function () {
        if (document.body.style.opacity !== '1') {
          document.body.style.opacity = '1';
          console.debug('[SWAK] Safety timeout fired — page revealed.');
        }
      }, 500);
    }
  }

// ===== SWAK CHANGE START — 2026-08-16 — Care Package Badge Gate =====
// Shows tier badge cards on unfiltered care package collection pages.
// Hides product grid until customer selects Plans, Packages, or Build Your Own.
// Backout: set SWAK_BADGE_GATE_ENABLED = false and upload.

// ===== SWAK CHANGE START — 2026-08-16 — Care Package Badge Gate =====
function applyCarePackageBadgeGate(d) {
  const SWAK_BADGE_GATE_ENABLED = true;
  if (!SWAK_BADGE_GATE_ENABLED) return;

  const CARE_COLLECTION_HANDLES = [
    'on-campus-welcome-event',
    'off-campus-welcome-event',
    'on-campus-halloween-event',
    'off-campus-halloween-event',
    'on-campus-fall-finals-event',
    'off-campus-fall-finals-event',
    'on-campus-valentines-event',
    'off-campus-valentines-event',
    'on-campus-spring-surprise-event',
    'off-campus-spring-surprise-event',
    'on-campus-spring-finals-event',
    'off-campus-spring-finals-event'
  ];

  const pathParts = window.location.pathname.split('/collections/');
  if (pathParts.length < 2) return;

  const afterCollections = pathParts[1];
  const segments = afterCollections.split('/');
  const currentHandle = segments[0];
  const isFiltered = segments.length > 1 && segments[1] !== '';

  if (!CARE_COLLECTION_HANDLES.includes(currentHandle)) return;
  if (isFiltered) return;

  const isOffCampus = currentHandle.startsWith('off-campus');
  const primaryColor = (d && d.primary_color) ? d.primary_color : '#8b6914';
  const baseUrl = window.location.pathname.replace(/\/$/, '');

  // 2026-08-17 — badge_bg and badge_text from color_buttons field — START
  const badgeParts = {};
  if (d && d.color_buttons) {
    d.color_buttons.split(';').forEach(function(pair) {
      const kv = pair.split('=');
      if (kv.length === 2 && kv[1].trim()) badgeParts[kv[0].trim()] = kv[1].trim();
    });
  }
  const badgeBg   = badgeParts['badge_bg']  || primaryColor;
  const badgeText = badgeParts['badge_text'] || '#ffffff';
  // 2026-08-17 — badge_bg and badge_text from color_buttons field — END

  // Inject badge gate CSS
  if (!document.getElementById('swak-badge-gate-styles')) {
    const style = document.createElement('style');
    style.id = 'swak-badge-gate-styles';
    style.textContent = [
      '.swak-badge-gate-hidden { display: none !important; }',
      '.swak-badge-gate-wrap { padding: 48px 24px; text-align: center; }',
      '.swak-badge-gate-intro { font-size: 1.1rem; margin-bottom: 32px; }',
      '.swak-badge-gate { display: flex; gap: 36px; justify-content: center; flex-wrap: wrap; }',
      '.swak-badge-card { flex: 1 1 320px; max-width: 420px; background-color: ' + badgeBg + '; color: ' + badgeText + '; border-radius: 12px; overflow: hidden; text-align: center; cursor: pointer; text-decoration: none; display: flex; flex-direction: column; align-items: center; justify-content: flex-start; transition: opacity 0.2s ease, transform 0.2s ease; box-shadow: 0 4px 12px rgba(0,0,0,0.15); }',
      '.swak-badge-card:hover { opacity: 0.88; transform: translateY(-3px); box-shadow: 0 8px 20px rgba(0,0,0,0.2); }',
      '.swak-badge-card__image { width: 100%; height: 320px; object-fit: cover; object-position: center; display: block; }',
      '.swak-badge-card__body { padding: 20px 16px 24px; width: 100%; border-top: 3px solid rgba(255,255,255,0.2); min-height: 80px; display: flex; flex-direction: column; align-items: center; justify-content: center; }',
      '.swak-badge-card__title { font-size: 1.05rem; font-weight: 700; color: ' + badgeText + '; margin-bottom: 4px; white-space: nowrap; }',
      '.swak-badge-card__subtitle { font-size: 0.82rem; opacity: 0.85; color: ' + badgeText + '; white-space: nowrap; }',
      '.swak-badge-card__image--contain { object-fit: contain !important; background: #ffffff; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  // Badge definitions
  const onCampusBadges = [
    {
      label: 'Plans',
      subtitle: 'Curated tier packages',
      filter: 'Plans',
      image: 'https://cdn.shopify.com/s/files/1/0668/0723/4603/files/multi-care-package-plans.png?v=1787453111',
      imageClass: 'swak-badge-card__image--contain'
    },
    {
      label: 'Packages',
      subtitle: 'Pre-built, ready to send',
      filter: 'Packages',
      image: 'https://cdn.shopify.com/s/files/1/0668/0723/4603/files/care-packages-badge.png?v=1786928041'
    },
    {
      label: 'Build Your Own',
      subtitle: 'Choose exactly what they need',
      filter: 'Build-Your-Own',
      image: 'https://cdn.shopify.com/s/files/1/0668/0723/4603/files/build-your-own-badge-tight-crop.png?v=1786929133'
    }
  ];

  const offCampusBadges = [
    {
      label: 'Packages',
      subtitle: 'Pre-built, ready to send',
      filter: 'Packages',
      image: 'https://cdn.shopify.com/s/files/1/0668/0723/4603/files/care-packages-badge.png?v=1786928041'
    },
    {
      label: 'Build Your Own',
      subtitle: 'Choose exactly what they need',
      filter: 'Build-Your-Own',
      image: 'https://cdn.shopify.com/s/files/1/0668/0723/4603/files/build-your-own-badge-image.png?v=1786927700'
    }
  ];

  const badges = isOffCampus ? offCampusBadges : onCampusBadges;

  const badgeHTML = badges.map(function(b) {
    return '<a class="swak-badge-card" href="' + baseUrl + '/' + b.filter + '">' +
      '<img class="swak-badge-card__image ' + (b.imageClass || '') + '" src="' + b.image + '" alt="' + b.label + '" loading="lazy">' +
      '<div class="swak-badge-card__body">' +
        '<div class="swak-badge-card__title">' + b.label + '</div>' +
        '<div class="swak-badge-card__subtitle">' + b.subtitle + '</div>' +
      '</div>' +
      '</a>';
  }).join('');

  const gateHTML = '<div class="swak-badge-gate-wrap">' +
    '<div class="swak-badge-gate-intro"><p>Choose how you\'d like to shop:</p></div>' +
    '<div class="swak-badge-gate">' + badgeHTML + '</div>' +
    '</div>';

  // Hide product grid, sidebar, results
  var grid    = document.querySelector('[data-testid="product-grid"]');
  var sidebar = document.querySelector('.collection-sidebar');
  var results = document.getElementById('ResultsList');
  var sortBar = document.querySelector('sorting-filter-component');

  if (grid)    grid.classList.add('swak-badge-gate-hidden');
  if (sidebar) sidebar.classList.add('swak-badge-gate-hidden');
  if (results) results.classList.add('swak-badge-gate-hidden');
  if (sortBar) sortBar.classList.add('swak-badge-gate-hidden');

  // Inject badge gate after collection wrapper
  var target = document.querySelector('.collection-wrapper') || document.querySelector('main');
  if (target) {
    var gateEl = document.createElement('div');
    gateEl.innerHTML = gateHTML;
    target.insertAdjacentElement('afterend', gateEl);
  }

  console.debug('[SWAK] Care package badge gate applied for:', currentHandle);
}
// ===== SWAK CHANGE END — 2026-08-16 — Care Package Badge Gate =====

  // ── Public API ────────────────────────────────────────────────────

  window.SWAK = window.SWAK || {};
  window.SWAK.getCampusSlug = getCampusSlug;
  window.SWAK.getCampusCookie = getCampusCookie;
  window.SWAK.setCampusCookie = setCampusCookie;
  window.SWAK.applyMegaMenuToggles = applyMegaMenuToggles;
  window.SWAK.wireHomeLink = wireHomeLink;
  window.SWAK.applyLandingPageSwaps = applyLandingPageSwaps; // Phase 0d

  // ── Boot ──────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
// SWAK 2026-07-11 — Patch header-menu deactivate with 400ms hover delay
// SWAK 2026-07-18 — Gate timer callback on isHovering flag to prevent stale close
document.addEventListener('DOMContentLoaded', function() {
  var hm = document.querySelector('header-menu');
  if (!hm) return;

  var originalDeactivate = hm.constructor.prototype.deactivate.bind(hm);
  var deactivateTimer = null;
  var isHovering = false;

  function startDeactivateTimer() {
    if (deactivateTimer) clearTimeout(deactivateTimer);
    deactivateTimer = setTimeout(function() {
      if (!isHovering) {
        originalDeactivate({
          target: hm,
          relatedTarget: null,
          type: 'mouseleave'
        });
      }
    }, 400);
  }

  function cancelDeactivateTimer() {
    if (deactivateTimer) {
      clearTimeout(deactivateTimer);
      deactivateTimer = null;
    }
  }

  hm.deactivate = function() {
    startDeactivateTimer();
  };

  hm.addEventListener('pointerenter', function() {
    isHovering = true;
    cancelDeactivateTimer();
  });

  hm.addEventListener('pointerleave', function() {
    isHovering = false;
  });

  document.querySelectorAll('.menu-list__list-item').forEach(function(li) {
    li.addEventListener('pointerenter', function() {
      isHovering = true;
      cancelDeactivateTimer();
    });
  });
});
// SWAK 2026-07-11 END — SWAK 2026-07-18 END
